import React from "react"
import autobind from "class-autobind"
import { Tabs, Tab } from "material-ui/Tabs"
import strings from "../../../localization/strings"
import ClientTypes from "./ClientTypes"
interface IProps {

}
interface IState {
	tabActive: string
}

export default class ClientSettings extends React.Component<IProps, IState> {
	constructor(props) {
		super(props)
		this.state = {
			tabActive: "client_types"
		}
		autobind(this)
	}

	render() {
		return (
			<div style={{ margin: -16, height: 400 }}>
				<Tabs
					value={this.state.tabActive}
					onChange={tabActive => this.setState({ tabActive })}
				>
					<Tab data-intercom-target={"menu-AccountSettings-ClientSettings-ClientTypesTab"} label={strings.Client_Types} value="client_types">
						{this.state.tabActive === "client_types" &&
							<ClientTypes />
						}
					</Tab>
				</Tabs>
			</div >
		)
	}
}